<template>
  <div class="content">
    <div v-if="statusMessage" class="status-message" :class="statusClass">
      {{ statusMessage }}
    </div>
    <button class="wx-pay" @click="startPayment">支付</button>
  </div>
</template>
<script setup>
  import { showToast } from 'vant';
  import { ref } from 'vue';
  import { onMounted, onUnmounted } from 'vue';
  // 状态
  const loading = ref(false);
  const sdkReady = ref(false);
  const statusMessage = ref('');
  const statusClass = ref('');

  // 检查是否在微信环境中
  const isWechatBrowser = () => {
    return /micromessenger/i.test(navigator.userAgent);
  };

  // 初始化微信SDK
  const initWechatSDK = async () => {
    if (!isWechatBrowser()) {
      statusMessage.value = '请在微信浏览器中打开此页面';
      statusClass.value = 'status-error';
      return;
    }

    try {
      loading.value = true;

      // 实际项目中需要从后端获取签名
      const signature = await fetchSignature();

      wx.config({
        debug: false,
        appId: 'wx696f2d460dff8faa', // 公众号AppID
        timestamp: Math.floor(Date.now() / 1000),
        nonceStr: generateNonceStr(16),
        signature: signature,
        jsApiList: [], // 不需要JSAPI
      });

      wx.ready(() => {
        console.log('微信JS-SDK 配置完成');
        sdkReady.value = true;
        loading.value = false;
      });

      wx.error(function (res) {
        console.error('微信JS-SDK 配置失败:', res);
        statusMessage.value = '支付功能初始化失败，请刷新页面' + JSON.stringify(res);
        statusClass.value = 'status-error';
        loading.value = false;
      });
    } catch (error) {
      console.error('初始化失败:', error);
      statusMessage.value = '支付功能初始化失败';
      statusClass.value = 'status-error';
      loading.value = false;
    }
  };

  // 模拟获取签名（实际项目中需要请求后端）
  const fetchSignature = () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve('b0d7b7a6f9f9f9f9f9f9f9f9f9f9f9f9');
      }, 500);
    });
  };

  // 生成随机字符串
  const generateNonceStr = (length) => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  };

  onMounted(() => {
    initWechatSDK();
  });

  const startPayment = () => {
    console.log('111');
    const paymentData = {
      orderCode: 'order123', // 订单号
      totalAmount: 100, // 订单金额
      notifyUrl: 'https://yournotifyurl.com', // 支付回调通知地址
    };

    // 向小程序发送支付请求
    if (window.wx && window.wx.miniProgram) {
      window.wx.miniProgram.navigateTo({
        url: '/pages-sub/webview/test/index?orderCode=order123&amount=100',
      });
      // window.wx.miniProgram.postMessage({
      //   data: {
      //     action: 'startPayment', // 操作类型，区分不同操作
      //     paymentData: paymentData,
      //   },
      // });
    }
  };
</script>
